module.exports = __webpack_public_path__ + "img/ben-paint.ec478fd1.jpg";